<template>
    <section class="comp_bookings_overview">
        <div class="comp_scroller">
            <div class="comp_content">
                <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle"
                        style="border-bottom: none; margin-bottom: 0">
                    <div class="col">
                        <h1 class="part_ui_heading" v-bind:class="{'mod--hidden':searchActive}">
                            <span>{{ $t('reservation_list') }}</span></h1>
                    </div>
                    <form class="col mod--flex-grow col--search mod--right" v-on:submit="doSearch">
                        <input ref="search" type="text" v-model="search" :placeholder="$t('search')"
                               v-bind:class="{'mod--active':searchActive}">
                        <button class="icon icon--search"></button>
                    </form>
                </header>
                <DateInputRangeHeader
                    :from="dateFrom"
                    :to="dateTo"
                    @inputFrom="v=>this.dateFrom=v"
                    @inputTo="v=>this.dateTo=v"/>
                <div class="wrp_comp_body reservation_list" :class="[loading ? 'state-loading' : '']"
                     style="min-height: 100px"
                     v-on:scroll="handleGlobalScroll($event)">
                    <div class="mod--row mod--row-4">
                        <template v-if="reservations.length > 0">
                            <div class="col col--12" v-for="reservation in reservations">
                                <part-reservation v-bind="reservation"
                                                  :detailLink="(id,row) => `/bookings/edit/${id}/${row}`"/>
                            </div>
                        </template>
                        <div class="col col--12" v-else>
                            <p>{{ $t('nothing_found') }}</p>
                        </div>
                        <div class="col col--12" v-if="loadingMore">
                            <div class="elm_comp_spinner">
                                <span class="icon--spinner animated--load"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import DateInputRangeHeader from '../part/item/date_input_range_header';
import {sanitize} from '../../main';

function tryParseDate(dateString) {
    const date = dateString ? moment(dateString).toDate() : undefined
    return (date && date.getDate && date.getDate()) ? date : undefined
}

export default {
    name: 'bookings-overview',
    data() {
        return {
            loading: false,
            loadingMore: false,
            count: null,
            reservations: [],
            search: '',
            limit: 25,
            offset: 0,
            searchActive: false,
            dateFrom: tryParseDate(this.$route.query.dateFrom),
            dateTo: tryParseDate(this.$route.query.dateTo)
        }
    },
    components: {
        DateInputRangeHeader
    },
    created() {
        this.getReservations(true);
    },
    watch: {
        dateFrom: function () {
            this.refresh()
        },
        dateTo: function () {
            this.refresh()
        }
    },
    mounted() {
        this.scroll();
    },
    methods: {
        doSearch: function (e) {
            e.preventDefault();
            if (this.searchActive === false) {
                this.searchActive = true;
                this.$nextTick(() => this.$refs.search.focus());
            } else {
                this.offset = 0;
                this.getReservations(true);
            }
        },
        scroll: function () {
            let elm = document.getElementsByClassName('reservation_list')[0];

            elm.onscroll = () => {
                let bottom = elm.scrollTop === (elm.scrollHeight - elm.offsetHeight);

                if (bottom && !this.loading && !this.loadingMore && (this.reservations.length < this.count)) {
                    this.offset += this.limit;
                    this.getReservations(false);
                }
            };
        },
        refresh() {
            let elm = document.getElementsByClassName('reservation_list')[0];
            elm.scrollTop = 0;
            this.offset = 0;
            this.getReservations(true)
        },
        getReservations: function (reload) {
            if (reload) {
                this.loading = true;
            } else {
                this.loadingMore = true;
            }

            let data = `
                    {
                        items {
                            id
                            name
                            note
                            is_group
                            created_at
                            reservation_rows {
                                id
                                reservation_number
                                check_in_date
                                check_out_date
                                guest_count
                                total_price_per_room
                                room_type_id
                                room_count
                                room_type {
                                    code
                                }
                                price_list {
                                    accommodation_currency {
                                        code_iso
                                    }
                                }
                                guests {
                                    profile {
                                        full_name
                                    }
                                    room {
                                        code
                                    }
                                }
                                canceled,
                                complete_profiles
                            }
                        },
                        pageInfo {
                            totalCount
                        }
                    }
                `;

            let dateFromFilter = '';
            let dateToFilter = '';

            if (this.dateFrom) {
                dateFromFilter = ', check_in_date: ":' + moment(this.dateTo).format('YYYY-MM-DD') + '"';
            }

            if (this.dateTo) {
                dateToFilter = ', check_out_date: "' + moment(this.dateFrom).format('YYYY-MM-DD') + ':"';
            }

            let query = `{
                    listReservations(order_by: "id|desc", search_anywhere: "%${sanitize(this.search)}%", limit: ${this.limit}, offset: ${this.offset}${dateFromFilter}${dateToFilter})
                    ${data}
                }`;

            axios({
                data: query
            }).then(response => {
                let self = this;
                let reservations = [];

                this.count = response.data.data.listReservations.pageInfo.totalCount;

                if (this.offset > 0) {
                    reservations = this.reservations;
                }

                response.data.data.listReservations.items.forEach(function (item) {
                    item.reservation_rows.forEach(function (row) {
                        let reservation = {};
                        reservation.id = item.id;
                        reservation.row = row.id;
                        reservation.room = row.room_type.code;
                        reservation.price = row.total_price_per_room;
                        reservation.checkin_date = moment(row.check_in_date).format('D. M.');
                        reservation.checkout_date = moment(row.check_out_date).format('D. M.');
                        reservation.guest_count = row.guest_count;
                        reservation.room_count = row.room_count;
                        reservation.icons = [];
                        reservation.group = item.is_group;
                        reservation.currency = row.price_list.accommodation_currency.code_iso;
                        reservation.status = row.canceled ? 'canceled' : 'new';
                        reservation.full_name = item.name;
                        reservation.room_numbers = [];
                        reservation.precheckin_complete = row.complete_profiles >= row.guest_count

                        if (row.guests[0] && !item.name) {
                            reservation.full_name = row.guests[0].profile.full_name;
                        }

                        if (row.guests) {
                            row.guests.forEach(function (item) {
                                if (item.room) {
                                    reservation.room_numbers.push(item.room.code);
                                }
                            });

                            reservation.room_numbers = [...new Set(reservation.room_numbers)];
                        }

                        reservations.push(reservation);
                    });
                });

                this.reservations = reservations;
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.loading = false;
                this.loadingMore = false
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/bookings-overview.vue